import { render, staticRenderFns } from "./AbstractForm.vue?vue&type=template&id=71f78ea2&scoped=true"
import script from "./AbstractForm.vue?vue&type=script&lang=js"
export * from "./AbstractForm.vue?vue&type=script&lang=js"
import style0 from "./AbstractForm.vue?vue&type=style&index=0&id=71f78ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f78ea2",
  null
  
)

export default component.exports